<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M605 1218 c-31 -36 -33 -85 -5 -121 11 -14 20 -36 20 -49 0 -116 110
-213 219 -193 95 17 151 91 151 201 0 82 -27 135 -85 169 -36 22 -52 24 -157
23 l-118 0 -25 -30z m53 -43 c-21 -31 -23 -32 -26 -13 -2 13 4 27 14 35 31 22
35 14 12 -22z m209 16 c40 -19 61 -46 78 -99 l7 -23 -40 20 c-22 11 -42 27
-45 36 -9 21 -40 19 -62 -5 -18 -20 -122 -57 -132 -47 -10 10 18 74 41 96 44
42 94 48 153 22z m9 -136 c20 -14 43 -25 50 -25 26 0 15 -48 -19 -83 -68 -73
-176 -56 -223 35 -17 34 -9 47 31 48 11 0 43 11 70 24 28 14 51 25 52 25 1 1
19 -10 39 -24z"
      />
      <path
        d="M260 1045 c-7 -8 -20 -15 -30 -15 -10 0 -23 -6 -29 -14 -6 -7 -30
-16 -53 -19 -26 -3 -51 -15 -67 -31 l-26 -26 -3 -256 -3 -255 35 -35 34 -34
182 0 182 0 34 34 35 35 -3 255 -3 256 -26 26 c-16 16 -41 28 -67 31 -23 3
-47 12 -53 19 -6 8 -18 14 -26 14 -8 0 -21 7 -29 15 -9 8 -28 15 -43 15 -16 0
-34 -7 -41 -15z m73 -25 c14 -11 32 -20 41 -20 10 0 16 -9 16 -25 0 -25 -1
-25 -90 -25 -89 0 -90 0 -90 25 0 16 6 25 16 25 9 0 27 9 41 20 14 11 29 20
33 20 4 0 19 -9 33 -20z m-153 -75 l0 -25 120 0 120 0 0 25 c0 20 5 25 27 25
15 0 37 -10 50 -22 23 -21 23 -23 23 -264 0 -133 -3 -250 -6 -259 -13 -34 -54
-40 -233 -35 -156 5 -174 7 -187 24 -11 16 -14 69 -14 265 0 237 1 245 22 268
13 13 33 23 50 23 23 0 28 -4 28 -25z"
      />
      <path
        d="M260 980 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10 -22
0 -40 -4 -40 -10z"
      />
      <path
        d="M165 860 c-3 -5 0 -13 7 -15 25 -10 258 0 258 10 0 14 -256 19 -265
5z"
      />
      <path
        d="M165 780 c-3 -5 0 -13 7 -15 25 -10 258 0 258 10 0 14 -256 19 -265
5z"
      />
      <path
        d="M210 682 c-24 -30 -25 -48 -5 -86 8 -15 15 -40 15 -55 0 -54 45 -69
61 -21 6 17 15 30 19 30 4 0 13 -13 19 -30 16 -48 61 -33 61 21 0 15 7 40 15
55 20 38 19 56 -5 86 -17 23 -26 25 -90 25 -64 0 -73 -2 -90 -25z m78 -14 c9
-9 15 -9 24 0 7 7 22 12 35 12 27 0 42 -43 24 -71 -6 -10 -11 -29 -11 -42 0
-36 -10 -38 -36 -9 l-24 27 -24 -27 c-26 -29 -36 -27 -36 9 0 13 -5 32 -11 42
-18 28 -3 71 24 71 13 0 28 -5 35 -12z"
      />
      <path
        d="M659 837 c-61 -21 -64 -24 -67 -56 -3 -31 -2 -33 13 -21 9 7 44 23
78 34 36 13 63 28 65 38 5 26 -21 27 -89 5z"
      />
      <path
        d="M893 853 c-30 -10 -9 -35 53 -63 37 -16 70 -27 75 -24 18 11 8 41
-18 54 -51 23 -98 37 -110 33z"
      />
      <path
        d="M1050 741 c0 -26 17 -36 35 -21 18 15 8 40 -16 40 -12 0 -19 -7 -19
-19z"
      />
      <path
        d="M947 693 c-14 -13 -6 -41 22 -80 45 -62 47 -80 16 -113 -29 -30 -29
-60 0 -60 21 0 20 -96 -2 -151 -14 -36 -24 -45 -78 -69 -71 -32 -97 -71 -77
-115 10 -22 9 -25 -13 -31 -13 -3 -49 2 -81 11 -38 11 -60 13 -67 6 -35 -35
56 -66 172 -58 96 6 187 44 233 96 80 91 117 250 99 423 -11 102 -25 141 -49
136 -19 -4 -20 -17 -3 -97 34 -166 -9 -364 -97 -443 -47 -43 -115 -66 -137
-48 -30 25 -18 50 38 74 99 45 118 83 127 246 7 138 4 152 -46 228 -34 51 -44
59 -57 45z"
      />
      <path
        d="M650 597 c-40 -21 -46 -28 -51 -66 l-5 -41 32 31 c38 37 103 62 122
47 23 -19 12 -38 -36 -62 -33 -17 -67 -48 -106 -95 -57 -71 -62 -75 -103 -72
-11 1 -24 -3 -28 -9 -9 -14 13 -40 35 -40 12 0 20 -14 29 -54 13 -60 34 -87
53 -68 8 8 8 21 0 50 -20 65 -15 80 48 157 43 53 74 80 105 94 61 27 76 60 50
109 -17 32 -25 37 -60 40 -27 2 -54 -5 -85 -21z"
      />
      <path
        d="M704 395 c-27 -27 -31 -63 -10 -104 16 -30 100 -111 115 -111 16 0
110 97 121 125 15 39 13 50 -15 83 -24 29 -29 30 -106 30 -72 0 -84 -2 -105
-23z m181 -46 c8 -23 -5 -46 -44 -83 l-31 -30 -40 39 c-35 35 -50 72 -35 87 3
3 37 5 75 5 58 0 71 -3 75 -18z"
      />
      <path
        d="M603 134 c-9 -23 13 -40 32 -24 12 10 13 16 4 26 -15 18 -28 18 -36
-2z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
